export enum SourceType {
	HeaderSearch = 'HeaderSearch'
}
